import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { useShallow } from 'zustand/react/shallow';

import { isAURegionSelector, useRegionStore } from '@packages/stores';

import { ExcessAmount } from '@components';
import { Radio } from '@elements/radio';
import { TextWithMd } from '@elements/text/textWithMd';
import { i18n } from '@i18n';
import { changeExcess } from '@store';
import { availableExcessLevelsSelector, useTripStore } from '@store';
import { sendAnalyticsEvent, testProps } from '@utils';

export function ChooseYourExcess() {
  const isAU = useRegionStore(isAURegionSelector);
  const tripExcessValue = useTripStore(state => state?.trip?.metaData?.excessAmount);
  const availableExcessValues = useTripStore(useShallow(availableExcessLevelsSelector));
  const [excessValue, setExcessValue] = useState(tripExcessValue);
  const [isLoading, setIsLoading] = useState<number>();

  const updateExcess = async (value: number) => {
    const currentExcessValue = tripExcessValue;
    setExcessValue(value);
    sendAnalyticsEvent('Excess Radio Button Clicked', { excessAmount: value });
    setIsLoading(value);
    const response = await changeExcess(value);
    setIsLoading(undefined);
    if (!response) {
      setExcessValue(currentExcessValue);
    }
  };

  if (!isAU) {
    return null;
  }

  if (!availableExcessValues) {
    return null;
  }

  const isSingularItem = availableExcessValues.length === 1;
  const descriptionText = !isSingularItem
    ? i18n.t('boostShared.excess.description.international')
    : i18n.t('boostShared.excess.description.domestic', { excessValue: tripExcessValue });

  return (
    <div className={twMerge('flex flex-col border-b mb-s16', !isSingularItem && 'mb-s32')}>
      <ExcessAmount className="mb-s16" />
      <TextWithMd className="mb-s16" variant="subHeading-14/r">
        {descriptionText}
      </TextWithMd>
      {!isSingularItem ? (
        <div className="flex  flex-row flex-wrap gap-s8 mb-s32 ">
          {availableExcessValues.map(it => {
            return (
              <Radio
                defaultBackgroundColor="primary"
                isLoading={isLoading === it}
                key={it}
                name={`excess`}
                title={`$${it}`}
                checked={excessValue === it}
                onChange={() => updateExcess(it)}
                id={'excess-' + it}
                {...testProps(`radio-excess-${it}`)}
              />
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
